import { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Pencil } from 'lucide-react';
import { toast } from 'sonner';
import { conciliacionProveedoresApi } from '../../../lib/api';

export function EditarFacturaRawDialog({ conciliacionId, row, onClose, onSaved }) {
  const [form, setForm] = useState({
    folio: row.folio || '',
    monto_total: row.monto_total ?? '',
    saldo_pendiente: row.saldo_pendiente ?? '',
    fecha_emision: row.fecha_emision || '',
    motivo: '',
  });
  const [saving, setSaving] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSave = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const payload = {
        index: row.index,
        folio_original: row.folio_original || null,
        folio: String(form.folio).trim() || null,
        monto_total: form.monto_total === '' ? null : Number(form.monto_total),
        saldo_pendiente: form.saldo_pendiente === '' ? null : Number(form.saldo_pendiente),
        fecha_emision: form.fecha_emision || null,
        motivo: form.motivo || '',
      };
      const res = await conciliacionProveedoresApi.editarFacturaRaw(conciliacionId, payload);
      const t = res.data?.conciliacion?.totales || {};
      toast.success(
        `✓ Factura corregida y rematcheada: ${t.match_perfecto || 0} OK · ${t.match_parcial || 0} parcial · ${t.faltante || 0} faltante`,
      );
      onSaved?.();
      onClose?.();
    } catch (e) {
      toast.error(`Error: ${e.response?.data?.detail || e.message}`);
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose?.(); }}>
      <DialogContent className="sm:max-w-md" data-testid="dialog-editar-factura-raw">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <Pencil className="w-4 h-4" /> Corregir dato del estado de cuenta
          </DialogTitle>
          <DialogDescription className="text-xs">
            Solo admin/gerencia. Úsalo cuando el proveedor envió un dato erróneo
            (ej: folio 1729 en vez de 1720). Se guarda auditoría del cambio y se
            re-ejecuta el matching contra Alegra.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs">Folio</Label>
            <Input value={form.folio} onChange={set('folio')} className="h-8 text-sm font-mono"
              data-testid="input-editar-folio" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs">Fecha emisión</Label>
            <Input type="date" value={form.fecha_emision} onChange={set('fecha_emision')}
              className="h-8 text-sm" data-testid="input-editar-fecha" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs">Monto total (CLP)</Label>
            <Input type="number" value={form.monto_total} onChange={set('monto_total')}
              className="h-8 text-sm" data-testid="input-editar-monto" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs">Saldo pendiente (CLP)</Label>
            <Input type="number" value={form.saldo_pendiente} onChange={set('saldo_pendiente')}
              className="h-8 text-sm" data-testid="input-editar-saldo" />
          </div>
          <div className="col-span-2 space-y-1">
            <Label className="text-xs">Motivo de la corrección (opcional)</Label>
            <Input value={form.motivo} onChange={set('motivo')} placeholder="ej: proveedor informó folio erróneo en EDC"
              className="h-8 text-sm" data-testid="input-editar-motivo" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={onClose} disabled={saving} data-testid="btn-cancelar-editar-raw">
            Cancelar
          </Button>
          <Button size="sm" onClick={handleSave} disabled={saving} data-testid="btn-guardar-editar-raw">
            {saving ? 'Guardando…' : 'Guardar y rematchear'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
